import { useEffect, useState } from 'react';

// True below Tailwind's `md` breakpoint (768px). Use it when a screen needs a different *structure* on phones
// (e.g. cards instead of a table that has inputs in it), so only one version is in the DOM.
const QUERY = '(max-width: 767px)';

export function useIsPhone() {
  const read = () => (typeof window !== 'undefined' && window.matchMedia ? window.matchMedia(QUERY).matches : false);
  const [isPhone, setIsPhone] = useState(read);
  useEffect(() => {
    const m = window.matchMedia(QUERY);
    const on = () => setIsPhone(m.matches);
    m.addEventListener('change', on);
    on();
    return () => m.removeEventListener('change', on);
  }, []);
  return isPhone;
}
